/**
 * Get the current user's chat identifier.
 * With Chat v2 (rooms API), we use the employee's prefix_id directly.
 * Falls back to legacy key_chat decoding for backwards compatibility.
 * @param keyChat - Base64 encoded key_chat from user employee data
 * @param employeeId - Employee prefix_id (EMP_xxx) — preferred
 * @returns User identifier for chat member comparison, or null if invalid
 */
export const getUserChatId = (keyChat: string | undefined, employeeId?: string): number | string | null => {
  // Prefer prefix_id when available (Chat v2)
  if (employeeId) return employeeId;

  if (!keyChat) return null;

  try {
    const decoded = atob(keyChat.trim()).trim();
    const parts = decoded.split("/");

    if (parts.length !== 2) return null;

    const userId = Number(parts[1]);
    return Number.isNaN(userId) ? null : userId;
  }
  catch {
    return null;
  }
};
